import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { WorkerService } from '../../api/services/worker.service';
import { AuthService } from '../../api/services/auth.service';
import { catchError, switchMap, take, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const workerService = inject(WorkerService);
  const authService = inject(AuthService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        const url = req.url;
        const isVerifyOtp = url.includes('/verify-otp');
        const hasWorkflowIdInBody = req.body && (
          (typeof req.body === 'string' && req.body.includes('68cf97738c07ccaa147d9b8b')) ||
          (typeof req.body === 'object' && JSON.stringify(req.body).includes('68cf97738c07ccaa147d9b8b'))
        );
        const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';
        const isInviteWorkflow =
          url.includes('68c3ed3d45a7a695efb493f5') ||
          router.url.includes('68c3ed3d45a7a695efb493f5') ||
          currentPath.includes('68c3ed3d45a7a695efb493f5');

        const isLoginWorkflow =
          url.includes('68cf97738c07ccaa147d9b8b') ||
          router.url.includes('68cf97738c07ccaa147d9b8b') ||
          router.url.includes('/login') ||
          currentPath.includes('68cf97738c07ccaa147d9b8b') ||
          currentPath.includes('/login') ||
          !!hasWorkflowIdInBody ||
          isInviteWorkflow;

        if (isLoginWorkflow) {
          if (isVerifyOtp) {
            router.navigateByUrl(router.url);
          }
          return throwError(() => error);
        }

        const refreshToken = localStorage.getItem('refreshToken');
        if (!refreshToken) {
          router.navigate(['/error/unauthorized']);
          return throwError(() => error);
        }

        // Prevent infinite loops by not intercepting auth/token endpoints
        if (
          !url.includes('/authentication/refresh-token') &&
          !url.includes('/authentication/verify-token')
        ) {
          localStorage.setItem('lastVisitedUrl', router.url);
          workerService.refreshToken();

          return authService.tokenRefreshed$.pipe(
            take(1),
            switchMap(() => {
              const newToken = localStorage.getItem('accessToken');
              const clonedReq = req.clone({
                headers: req.headers.set('Authorization', `Bearer ${newToken}`),
              });
              return next(clonedReq);
            }),
          );
        }
      }
      return throwError(() => error);
    }),
  );
};
